import { useState } from 'react';
import { faChartLine, faFilter, faInfo } from '@fortawesome/free-solid-svg-icons'
import { Line } from 'react-chartjs-2'; // Importamos el gráfico de líneas
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    PointElement,
    LineElement,
    Tooltip,
    Legend,
} from 'chart.js';
import TableComp from '../../components/Table'
import CustomTitle from '../../components/CustomTitle';
import ButtonIcon from '../../components/ButtonComp';
import CustomLayout from 'components/Layout';

// Registramos los elementos necesarios de Chart.js
ChartJS.register(CategoryScale, LinearScale, PointElement, LineElement, Tooltip, Legend);

type Props = {}

const TrendGraphManagement = (props: Props) => {
    const [showGraph, setShowGraph] = useState(false); // Estado para mostrar/ocultar el gráfico
    const [selectedGraph, setSelectedGraph] = useState<any>(null); // Estado para seleccionar el gráfico

    // Datos ficticios para el gráfico
    const graphData = {
        labels: ['Ene', 'Feb', 'Mar', 'Abr', 'May', 'Jun', 'Jul'], // Meses
        datasets: [
            {
                label: 'Tendencia de tráfico',
                data: [120, 150, 170, 200, 220, 250, 270], // Datos ficticios
                borderColor: 'rgba(75, 192, 192, 1)',
                backgroundColor: 'rgba(75, 192, 192, 0.2)',
                fill: true,
            },
        ],
    };

    // Función para manejar el clic en el botón "Ver gráfico"
    const handleGraphClick = (graph: any) => {
        setSelectedGraph(graph);
        setShowGraph(true); // Muestra el gráfico cuando se hace clic
    };

    // Función para manejar el clic en "Ver detalles" (muestra detalles en la consola)
    const handleDetailsClick = (row: any) => {
        console.log("Detalles del gráfico:", row);
    };

    return (
        <CustomLayout>
            <CustomTitle
                title='Gráficos de Tendencia'
                actions={[
                    <ButtonIcon icon={faFilter} tooltip='Filtrar resultados' variant='outline-primary'/>
                ]}
            />
            {!showGraph ? (
                <TableComp
                    headers={['#', 'Tipo de Gráfico', 'Descripción', 'Fecha de inicio', 'Fecha de fin', 'Acciones']}
                    keys={['id', 'graph_type', 'description', 'start_date', 'end_date']}
                    body={[
                        { id: 1, graph_type: "Tendencia de tráfico", description: "Evolución del tráfico en los últimos 7 días", start_date: "2025-01-19T00:00:00", end_date: "2025-01-26T00:00:00" },
                        { id: 2, graph_type: "Tendencia de accidentes", description: "Comparativa de accidentes en los últimos 30 días", start_date: "2025-01-01T00:00:00", end_date: "2025-01-30T00:00:00" },
                        { id: 3, graph_type: "Tendencia de congestión", description: "Niveles de congestión en las principales autopistas", start_date: "2025-01-10T00:00:00", end_date: "2025-01-25T00:00:00" },
                        { id: 4, graph_type: "Tendencia de condiciones meteorológicas", description: "Gráfico de cambios climáticos a lo largo del mes", start_date: "2025-01-01T00:00:00", end_date: "2025-01-31T00:00:00" },
                        { id: 5, graph_type: "Tendencia de velocidad media", description: "Velocidades promedio registradas en las últimas 24 horas", start_date: "2025-01-25T00:00:00", end_date: "2025-01-26T00:00:00" },
                    ]}
                    actions={[
                        {
                            icon: faChartLine,
                            handleClick: (row: any) => handleGraphClick(row),
                            tooltip: "Ver gráfico",
                            variant: "outline-primary"
                        },
                        {
                            icon: faInfo,
                            handleClick: handleDetailsClick,
                            tooltip: "Ver detalles",
                            variant: "outline-info"
                        }
                    ]}
                    moment_dates={[{ index: 3, format: "LLL" }, { index: 4, format: "LLL" }]}
                />
            ) : (
                <div>
                    <button onClick={() => setShowGraph(false)}>Volver a la tabla</button> {/* Botón para volver a la tabla */}
                    <h2>{selectedGraph?.graph_type} - Gráfico</h2>
                    <Line data={graphData} /> {/* Renderizado del gráfico */}
                </div>
            )}
        </CustomLayout>
    )
}

export default TrendGraphManagement;
